export default "__VITE_ASSET__D5QVbw$R__"